(function () {
  var DEFAULT_TITLES = {
    usage: 'What do you need your glasses for?',
    submissionMethod: 'Choose how to add your prescription',
    lensGroup: 'Lens type',
    lenses: 'Choose lens package',
    transitionType: 'Choose transition type',
    progressiveType: 'Choose progressive type',
    addOns: 'Available Upgrades'
  };

  var ADDONS_STEP_SELECTOR = '.la-choose-prescription-wrapper.la-render-addons';
  var LENSES_STEP_SELECTOR = '.la-choose-prescription-wrapper.la-render-lenses:not(.x-pro)';
  var LENS_GROUP_STEP_SELECTOR = '.la-choose-prescription-wrapper.la-render-lenses.x-pro';
  var THICKNESS_STEP_SELECTOR = '.la-choose-prescription-wrapper.la-render-options';

  var USAGE_STEP_SELECTOR =
    window.ciwLaUsageStepSelector ||
    '.la-choose-prescription-wrapper:not(.la-render-lenses):not(.la-render-options):not(.la-render-review):not(.la-render-addons)';

  function isEyeglassFlow() {
    if (!window.ciwLaHostApi) return !!document.querySelector('.ciw-pdp');
    return window.ciwLaHostApi.isActive() && !window.ciwLaHostApi.isContactLens();
  }

  function normalizeLensLabel(text) {
    return String(text || '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function isNonTransitionsLensGroupTitle(title) {
    return /^(clear|blue\s*light|sunglass(?:es)?|polarized|non[\s-]?polarized)\b/i.test(
      normalizeLensLabel(title)
    );
  }

  function isTransitionsGroupTitle(title) {
    var label = normalizeLensLabel(title);
    if (!label || isNonTransitionsLensGroupTitle(label)) return false;
    return /\btransitions?\b|photochromic|xtr\s*active|xtractive/i.test(label);
  }

  function isLikelyTransitionTypeName(name) {
    var label = normalizeLensLabel(name);
    if (!label || isLikelyThicknessTierName(label)) return false;
    return /gen\s*s|photochromic|xtr\s*active|xtractive|\btransitions?\b/i.test(label);
  }

  function isLikelyThicknessTierName(name) {
    return /^(basic|standard|polycarbonate|premium|supreme\+?)$/i.test(
      String(name || '')
        .replace(/\s+/g, ' ')
        .trim()
        .split(' - ')[0]
    );
  }

  var COLOR_STEP_DISPLAY_TITLE = 'Select color';

  function isLensColorOptionTitle(title) {
    var label = normalizeLensLabel(title);
    return (
      /select\s+choose\s+color\s+for\s+photo\s*c?r?omic/i.test(label) ||
      /choose\s+color\s+for\s+photo\s*c?r?omic/i.test(label) ||
      /select\s+choose\s+color/i.test(label) ||
      /select\s+transition\s+color\s+for\s+transitions\s+gen\s*s/i.test(label) ||
      /select\s+transition\s+color/i.test(label) ||
      /select\s+transition\s+x\s*tract?ive\s+color\s+for\s+transitions\s+xtr\s*active/i.test(label) ||
      /select\s+transition\s+x\s*tract?ive\s+color/i.test(label) ||
      /(?:photo\s*c?r?omic|transitions?\s+gen\s*s|transitions?\s+xtr\s*active|xtractive).+\bcolor\b|\bcolor\b.+(?:photo\s*c?r?omic|transitions?\s+gen\s*s|xtr\s*active|xtractive)/i.test(
        label
      ) ||
      /select\s*color|select\s*transition|transition\s*color|lens\s*color|photochromic\s*color|xtr\s*active\s*color|xtractive\s*color|^color$/i.test(
        label
      )
    );
  }

  function isLikelyLensColorCardName(name) {
    var label = normalizeLensLabel(name).split(' - ')[0];
    if (!label || isLikelyThicknessTierName(label) || isLikelyTransitionTypeName(label)) {
      return false;
    }
    return /^(gray|grey|brown|green|graphite|amber|amethyst|ruby|sapphire|emerald|g[\s.-]?15|style\s*colors?)/i.test(
      label
    );
  }

  function getLensAdvizorCustomOptionValue(la, keyPattern) {
    if (!la) return '';

    var sources = [la.customOptions || {}, la.customFieldData || {}];
    var i;
    var j;
    var source;
    var keys;
    var key;

    for (i = 0; i < sources.length; i++) {
      source = sources[i];
      keys = Object.keys(source);
      for (j = 0; j < keys.length; j++) {
        key = keys[j];
        if (keyPattern.test(key)) return normalizeLensLabel(source[key]);
      }
    }

    return '';
  }

  function getSelectedTransitionTypeFromDom() {
    var lensesStep = document.querySelector(LENSES_STEP_SELECTOR);
    if (!lensesStep) return '';

    var checked = lensesStep.querySelector('input[type="radio"].la-tap-select:checked');
    if (checked) {
      var checkedBtn = checked.closest('.la-label-btn');
      var checkedTitleNode = checkedBtn && checkedBtn.querySelector('.la-label-title');
      var checkedLabel = checkedTitleNode ? checkedTitleNode.textContent : checked.value || '';
      checkedLabel = normalizeLensLabel(checkedLabel);
      if (isLikelyTransitionTypeName(checkedLabel)) return checkedLabel;
    }

    var pickedTitleNode = lensesStep.querySelector('.ciw-la-lens-card--picked .la-label-title');
    if (pickedTitleNode) {
      var pickedLabel = normalizeLensLabel(pickedTitleNode.textContent);
      if (isLikelyTransitionTypeName(pickedLabel)) return pickedLabel;
    }

    return '';
  }

  function getSelectedTransitionTypeName() {
    var la = window.LensAdvizor;

    if (la) {
      var chooseLenses = getLensAdvizorCustomOptionValue(la, /choose\s*your\s*lenses/i);
      if (chooseLenses && isLikelyTransitionTypeName(chooseLenses)) {
        return chooseLenses;
      }

      if (la.response && la.response.lens && la.response.lens.name) {
        var lensName = normalizeLensLabel(la.response.lens.name);
        if (isLikelyTransitionTypeName(lensName)) return lensName;
      }
    }

    return getSelectedTransitionTypeFromDom();
  }

  function classifyTransitionType(label) {
    label = normalizeLensLabel(label);
    if (!label) return null;
    if (/photochromic/i.test(label) && !/gen\s*s|xtr\s*active|xtractive/i.test(label)) {
      return 'photochromic';
    }
    if (/xtr\s*active|xtractive/i.test(label)) return 'xtr-active';
    if (/gen\s*s/i.test(label)) return 'gen-s';
    return null;
  }

  function getColorStepTitle() {
    return COLOR_STEP_DISPLAY_TITLE;
  }

  function countCardTypes(scope) {
    var wrappers = scope.querySelectorAll('.la-label-btn-wrapper');
    var tierCount = 0;
    var typeCount = 0;
    var colorCount = 0;
    var i;

    for (i = 0; i < wrappers.length; i++) {
      var titleNode = wrappers[i].querySelector('.la-label-title');
      var cardTitle = titleNode ? normalizeLensLabel(titleNode.textContent) : '';
      if (isLikelyThicknessTierName(cardTitle)) tierCount++;
      else if (isLikelyTransitionTypeName(cardTitle)) typeCount++;
      else if (isLikelyLensColorCardName(cardTitle)) colorCount++;
    }

    return {
      wrappers: wrappers.length,
      tierCount: tierCount,
      typeCount: typeCount,
      colorCount: colorCount
    };
  }

  function isTransitionTypeScope(scope) {
    if (!scope) return false;
    var counts = countCardTypes(scope);
    return counts.typeCount >= 1 && counts.tierCount < 2 && counts.colorCount < 2;
  }

  function isColorOptionScope(scope) {
    if (!scope) return false;
    if (!isTransitionsLensFlow()) return false;
    if (isProgressiveTypeStep(scope)) return false;

    if (
      window.ciwLaLensColorContinue &&
      typeof window.ciwLaLensColorContinue.isCombinedColorPhase === 'function' &&
      window.ciwLaLensColorContinue.isCombinedColorPhase()
    ) {
      var combinedCounts = countCardTypes(scope);
      if (combinedCounts.colorCount >= 1 && combinedCounts.tierCount >= 2) {
        return true;
      }
    }

    var titleEl =
      scope.querySelector('#la_prescriptionSelect_title') ||
      scope.querySelector('.la-wrapper-heading h3');
    var title = titleEl ? normalizeLensLabel(titleEl.textContent) : '';
    if (isLensColorOptionTitle(title)) return true;

    if (isThicknessOptionScope(scope)) return false;
    if (isTransitionTypeScope(scope)) return false;

    var counts = countCardTypes(scope);
    if (counts.colorCount >= 1) return true;
    if (counts.wrappers >= 2 && counts.tierCount < 2 && counts.typeCount < 1) return true;

    return false;
  }

  function isTransitionsLensFlowFromLensAdvizor(la) {
    la = la || window.LensAdvizor;
    if (!la || !la.response) return false;

    if (la.lensGroups && la.response.lensGroupSelected) {
      var selectedKey = la.response.lensGroupSelected;
      var i;
      for (i = 0; i < la.lensGroups.length; i++) {
        var group = la.lensGroups[i];
        if (group.group_type !== selectedKey && String(group.id) !== String(selectedKey)) {
          continue;
        }
        if (isTransitionsGroupTitle(group.group_title || group.title || '')) {
          return true;
        }
      }
    }

    return false;
  }

  function isTransitionsLensFlowFromDom() {
    var groupStep = document.querySelector(LENS_GROUP_STEP_SELECTOR);
    if (!groupStep) return false;

    var checked = groupStep.querySelector('input[type="radio"].la-tap-select:checked');
    if (!checked) return false;

    var btn = checked.closest('.la-label-btn');
    var titleNode = btn && btn.querySelector('.la-label-title');
    var label = titleNode ? titleNode.textContent : checked.value || '';
    return isTransitionsGroupTitle(label);
  }

  function isTransitionsLensFlow() {
    return isTransitionsLensFlowFromLensAdvizor() || isTransitionsLensFlowFromDom();
  }

  function getSelectedUsageLabel() {
    var la = window.LensAdvizor;
    if (la && la.response && la.response.selectedPrescriptionType) {
      var selected = la.response.selectedPrescriptionType;
      if (selected && selected.title) {
        if (la.Translation && typeof la.Translation.getTranslatedText === 'function') {
          try {
            var translated = la.Translation.getTranslatedText(selected.title);
            if (translated) return normalizeLensLabel(translated);
          } catch (err) {
            /* fall through */
          }
        }
        if (typeof selected.title === 'string') return normalizeLensLabel(selected.title);
      }
    }

    var modal = document.getElementById('lensadvizor-prescription-modal');
    if (!modal) return '';

    var usageWrapper = modal.querySelector(USAGE_STEP_SELECTOR);
    if (!usageWrapper) return '';

    var checked = usageWrapper.querySelector('input[type="radio"]:checked');
    if (!checked) return '';

    var btn = checked.closest('.la-label-btn, label.la-label-btn, label');
    var titleEl = btn && btn.querySelector('.la-label-title');
    return titleEl ? normalizeLensLabel(titleEl.textContent) : '';
  }

  function isProgressivePrescriptionFlow() {
    var la = window.LensAdvizor;
    if (la && la.response && la.response.selectedPrescriptionType) {
      var selected = la.response.selectedPrescriptionType;
      var text = '';
      if (typeof selected === 'string') {
        text = selected;
      } else if (selected) {
        text = [selected.title, selected.name, selected.type, selected.handle]
          .filter(Boolean)
          .join(' ');
      }
      if (/progressive/i.test(text)) return true;
    }
    return /progressive/i.test(getSelectedUsageLabel());
  }

  function isProgressiveTypeStep(scope) {
    if (!scope || !isProgressivePrescriptionFlow()) return false;
    var counts = countCardTypes(scope);
    return counts.wrappers >= 3 && counts.tierCount === 0 && counts.colorCount === 0;
  }

  function isLikelyProgressiveTypeCardName(name) {
    var label = normalizeLensLabel(name).split(' - ')[0];
    if (
      !label ||
      isLikelyThicknessTierName(label) ||
      isLikelyTransitionTypeName(label) ||
      isLikelyLensColorCardName(label)
    ) {
      return false;
    }
    return true;
  }

  function getSelectedProgressiveTypeNameFromDom() {
    var lensesStep = document.querySelector(LENSES_STEP_SELECTOR);
    if (!lensesStep) return '';

    function cardNameFromWrapper(wrapper) {
      var titleNode = wrapper && wrapper.querySelector('.la-label-title');
      return titleNode ? normalizeLensLabel(titleNode.textContent).split(' - ')[0] : '';
    }

    var checked = lensesStep.querySelector('input[type="radio"].la-tap-select:checked');
    if (checked) {
      var checkedLabel = cardNameFromWrapper(checked.closest('.la-label-btn-wrapper'));
      if (isLikelyProgressiveTypeCardName(checkedLabel)) return checkedLabel;
    }

    var pickedTitleNode = lensesStep.querySelector('.ciw-la-lens-card--picked .la-label-title');
    if (pickedTitleNode) {
      var pickedLabel = normalizeLensLabel(pickedTitleNode.textContent).split(' - ')[0];
      if (isLikelyProgressiveTypeCardName(pickedLabel)) return pickedLabel;
    }

    return '';
  }

  function getSelectedProgressiveTypeName() {
    var la = window.LensAdvizor;
    var i;
    var patterns = [
      /progressive\s*type/i,
      /choose\s*progressive/i,
      /lens\s*design/i,
      /choose\s*your\s*lenses/i
    ];

    if (la) {
      for (i = 0; i < patterns.length; i++) {
        var optionValue = getLensAdvizorCustomOptionValue(la, patterns[i]);
        if (optionValue && isLikelyProgressiveTypeCardName(optionValue.split(' - ')[0])) {
          return optionValue.split(' - ')[0];
        }
      }

      if (la.response && la.response.lens && la.response.lens.name) {
        var lensName = normalizeLensLabel(la.response.lens.name).split(' - ')[0];
        if (isLikelyProgressiveTypeCardName(lensName)) return lensName;
      }
    }

    return getSelectedProgressiveTypeNameFromDom();
  }

  function isScopeVisible(scope) {
    if (!scope || scope.hasAttribute('hidden')) return false;
    var style = window.getComputedStyle(scope);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    return scope.getClientRects().length > 0;
  }

  function getProgressivePackageStep() {
    if (!isProgressivePrescriptionFlow() || isTransitionsLensFlow()) return null;
    if (!getSelectedProgressiveTypeName()) return null;

    var lensesStep = document.querySelector(LENSES_STEP_SELECTOR);
    if (lensesStep && isScopeVisible(lensesStep) && isProgressiveTypeStep(lensesStep)) return null;

    var scope = document.querySelector(THICKNESS_STEP_SELECTOR);
    if (!scope || !isScopeVisible(scope) || isColorOptionScope(scope)) return null;

    var counts = countCardTypes(scope);
    if (counts.tierCount >= 2 && counts.colorCount === 0) return scope;

    return null;
  }

  function getProgressivePackageStepTitle() {
    var name = getSelectedProgressiveTypeName();
    if (!name) return getTitles().lenses;
    return 'Choose lens package for ' + name;
  }

  function isTransitionTypeStep(scope) {
    scope = scope || document.querySelector(LENSES_STEP_SELECTOR);
    if (!scope) return false;

    var wrappers = scope.querySelectorAll('.la-label-btn-wrapper');
    if (!wrappers.length) return false;

    var typeCount = 0;
    var tierCount = 0;
    var i;
    for (i = 0; i < wrappers.length; i++) {
      var titleNode = wrappers[i].querySelector('.la-label-title');
      var cardTitle = titleNode ? titleNode.textContent.replace(/\s+/g, ' ').trim() : '';
      if (isLikelyThicknessTierName(cardTitle)) tierCount++;
      else if (isLikelyTransitionTypeName(cardTitle)) typeCount++;
    }

    return typeCount >= 1 && tierCount < 2;
  }

  function isThicknessOptionScope(scope) {
    if (!scope || !scope.classList.contains('la-render-options')) return false;

    var titleEl =
      scope.querySelector('#la_prescriptionSelect_title') ||
      scope.querySelector('.la-wrapper-heading h3');
    var title = titleEl ? titleEl.textContent.replace(/\s+/g, ' ').trim() : '';
    if (isLensColorOptionTitle(title)) return false;

    var wrappers = scope.querySelectorAll('.la-label-btn-wrapper');
    if (!wrappers.length) return false;

    var tierCount = 0;
    var colorCount = 0;
    var i;
    for (i = 0; i < wrappers.length; i++) {
      var titleNode = wrappers[i].querySelector('.la-label-title');
      var cardTitle = titleNode ? titleNode.textContent.replace(/\s+/g, ' ').trim() : '';
      if (isLikelyThicknessTierName(cardTitle)) tierCount++;
      else if (isLikelyLensColorCardName(cardTitle)) colorCount++;
    }

    if (colorCount >= 1 && tierCount < 2) return false;

    if (/lens\s*thickness|lens\s*material|^material$/i.test(title)) return true;
    if (/choose\s*lens\s*package/i.test(title)) return tierCount >= 2;
    return tierCount >= 2;
  }

  function getThicknessStep() {
    var scope = document.querySelector(THICKNESS_STEP_SELECTOR);
    if (!scope || !isTransitionsLensFlow() || !isThicknessOptionScope(scope)) return null;
    if (isColorOptionScope(scope)) return null;
    if (
      window.ciwLaLensColorContinue &&
      typeof window.ciwLaLensColorContinue.isCombinedColorPhase === 'function' &&
      window.ciwLaLensColorContinue.isCombinedColorPhase()
    ) {
      var phaseCounts = countCardTypes(scope);
      if (phaseCounts.colorCount >= 1 && phaseCounts.tierCount >= 2) return null;
    }
    if (
      window.ciwLaLensColorContinue &&
      typeof window.ciwLaLensColorContinue.isColorScope === 'function' &&
      window.ciwLaLensColorContinue.isColorScope(scope)
    ) {
      return null;
    }
    return scope;
  }

  function getColorStep() {
    var selectors = [THICKNESS_STEP_SELECTOR, LENSES_STEP_SELECTOR];
    var i;
    for (i = 0; i < selectors.length; i++) {
      var scope = document.querySelector(selectors[i]);
      if (scope && isColorOptionScope(scope)) return scope;
    }
    return null;
  }

  // In a transitions progressive flow the "choose progressive type" step renders on the
  // .la-render-options wrapper (not .la-render-lenses), so it needs its own title handling.
  function getProgressiveTypeOptionsStep() {
    if (!isProgressivePrescriptionFlow()) return null;

    var scopes = document.querySelectorAll(THICKNESS_STEP_SELECTOR);
    var i;
    for (i = 0; i < scopes.length; i++) {
      if (!isScopeVisible(scopes[i])) continue;
      if (isProgressiveTypeStep(scopes[i])) return scopes[i];
    }

    var tagged = document.querySelector('.ciw-la-progressive-type-options-step');
    if (tagged && isScopeVisible(tagged)) return tagged;

    return null;
  }

  function getModalTitleEl() {
    return document.querySelector(
      '#lensadvizor-prescription-modal #la_prescriptionSelect_title, #lensadvizor-prescription-modal .la-wrapper-heading h3:not(.ciw-la-transitions-drawer__title)'
    );
  }

  function setModalStepTitle(title) {
    var titleEl = getModalTitleEl();
    if (!titleEl || !title) return false;
    if (titleEl.textContent.trim() === title) return true;
    titleEl.textContent = title;
    return true;
  }

  function getTitles() {
    var config = window.ciwLaStepTitles || {};
    return {
      usage: config.usage || DEFAULT_TITLES.usage,
      submissionMethod: config.submissionMethod || DEFAULT_TITLES.submissionMethod,
      lensGroup: config.lensGroup || DEFAULT_TITLES.lensGroup,
      lenses: config.lenses || DEFAULT_TITLES.lenses,
      transitionType: config.transitionType || DEFAULT_TITLES.transitionType,
      progressiveType: config.progressiveType || DEFAULT_TITLES.progressiveType,
      addOns: config.addOns || DEFAULT_TITLES.addOns
    };
  }

  function getLensesStepTitle() {
    var titles = getTitles();
    if (
      window.ciwLaSunglassesLensSelection &&
      typeof window.ciwLaSunglassesLensSelection.isActive === 'function' &&
      window.ciwLaSunglassesLensSelection.isActive()
    ) {
      return window.ciwLaSunglassesLensSelection.getStepTitle();
    }
    if (
      window.ciwLaTransitionsDrawer &&
      typeof window.ciwLaTransitionsDrawer.isActive === 'function' &&
      window.ciwLaTransitionsDrawer.isActive()
    ) {
      return window.ciwLaTransitionsDrawer.getStepTitle();
    }
    var lensesStep = document.querySelector(LENSES_STEP_SELECTOR);
    if (isTransitionsLensFlow() && isTransitionTypeStep(lensesStep)) {
      return titles.transitionType;
    }
    if (!isTransitionsLensFlow() && isProgressiveTypeStep(lensesStep)) {
      return titles.progressiveType || 'Choose progressive type';
    }
    return titles.lenses;
  }

  function getSteps() {
    var titles = getTitles();
    var steps = [
      {
        selector: USAGE_STEP_SELECTOR,
        title: titles.usage
      },
      {
        selector: '.la-prescription-wrapper:not(form)',
        title: titles.submissionMethod
      },
      {
        selector: LENS_GROUP_STEP_SELECTOR,
        title: titles.lensGroup
      },
      {
        selector: LENSES_STEP_SELECTOR,
        title: getLensesStepTitle()
      },
      {
        selector: ADDONS_STEP_SELECTOR,
        title: titles.addOns
      }
    ];

    if (getProgressivePackageStep()) {
      steps.push({
        selector: THICKNESS_STEP_SELECTOR,
        title: getProgressivePackageStepTitle(),
        progressivePackage: true
      });
    }

    return steps;
  }

  function setTitle(wrapper, title) {
    if (!wrapper) return false;
    var titleEl =
      wrapper.querySelector('#la_prescriptionSelect_title') ||
      wrapper.querySelector('.la-wrapper-heading h3');
    if (!titleEl) return false;
    if (titleEl.textContent.trim() === title) return true;
    titleEl.textContent = title;
    return true;
  }

  function getLensPackageOptionsStep() {
    var scopes = document.querySelectorAll(THICKNESS_STEP_SELECTOR);
    var i;
    for (i = 0; i < scopes.length; i++) {
      var scope = scopes[i];
      if (!isScopeVisible(scope)) continue;
      if (isColorOptionScope(scope)) continue;
      if (isProgressiveTypeStep(scope)) continue;

      var title = '';
      var titleEl =
        scope.querySelector('#la_prescriptionSelect_title') ||
        scope.querySelector('.la-wrapper-heading h3');
      if (titleEl) title = normalizeLensLabel(titleEl.textContent);

      if (/choose\s+lens\s+package/i.test(title)) return scope;

      var counts = countCardTypes(scope);
      if (counts.tierCount >= 2 && counts.colorCount === 0) return scope;
    }
    return null;
  }

  function getLensPackageStepTitle(scope) {
    var titleEl =
      (scope && scope.querySelector('#la_prescriptionSelect_title')) ||
      (scope && scope.querySelector('.la-wrapper-heading h3'));
    var raw = titleEl ? normalizeLensLabel(titleEl.textContent) : '';
    var cleaned = raw.replace(/^select\s+/i, '').trim();
    var match = cleaned.match(/choose\s+lens\s+package\s+for\s+(.+)/i);
    if (match) return 'Choose lens package for ' + match[1].trim();

    var la = window.LensAdvizor;
    if (la && la.response && la.response.lens && la.response.lens.name) {
      return 'Choose lens package for ' + normalizeLensLabel(la.response.lens.name);
    }

    return getTitles().lenses;
  }

  var titlesRunning = false;
  var titlesBurstQueued = false;

  function updateStepTitles() {
    if (titlesRunning) return;
    if (!isEyeglassFlow()) return;
    titlesRunning = true;
    try {

    var colorStep = getColorStep();
    var progressiveTypeStep = getProgressiveTypeOptionsStep();
    var thicknessStep = getThicknessStep();
    var progressivePackageStep = getProgressivePackageStep();

    getSteps().forEach(function (step) {
      var wrapper = document.querySelector(step.selector);
      if (!wrapper) return;
      if (colorStep && wrapper === colorStep) return;
      if (progressivePackageStep && step.selector === LENSES_STEP_SELECTOR) return;
      if (
        progressivePackageStep &&
        step.progressivePackage &&
        wrapper !== progressivePackageStep
      ) {
        return;
      }
      if (step.selector === LENSES_STEP_SELECTOR && isColorOptionScope(wrapper)) return;
      setTitle(wrapper, step.title);
    });

    if (thicknessStep && thicknessStep !== progressiveTypeStep) {
      setTitle(thicknessStep, getTitles().lenses);
    }

    if (progressivePackageStep) {
      setTitle(progressivePackageStep, getProgressivePackageStepTitle());
    }

    if (colorStep) {
      var colorTitle = getColorStepTitle();
      if (colorTitle) setTitle(colorStep, colorTitle);
    }

    var lensPackageStep = getLensPackageOptionsStep();
    if (
      lensPackageStep &&
      lensPackageStep !== progressivePackageStep &&
      lensPackageStep !== progressiveTypeStep
    ) {
      var packageTitle = getLensPackageStepTitle(lensPackageStep);
      setTitle(lensPackageStep, packageTitle);
      setModalStepTitle(packageTitle);
    }

    var addonsStep = document.querySelector(ADDONS_STEP_SELECTOR);
    if (addonsStep && isScopeVisible(addonsStep)) {
      var addonsTitle = getTitles().addOns;
      setTitle(addonsStep, addonsTitle);
      setModalStepTitle(addonsTitle);
    }

    var PROG_TYPE_STEP_CLASS = 'ciw-la-progressive-type-options-step';
    document.querySelectorAll('.' + PROG_TYPE_STEP_CLASS).forEach(function (el) {
      if (el !== progressiveTypeStep) el.classList.remove(PROG_TYPE_STEP_CLASS);
    });
    if (progressiveTypeStep && progressiveTypeStep !== colorStep) {
      var progTypeTitle = getTitles().progressiveType || 'Choose progressive type';
      progressiveTypeStep.classList.add(PROG_TYPE_STEP_CLASS);
      setTitle(progressiveTypeStep, progTypeTitle);
      setModalStepTitle(progTypeTitle);
    }
    } finally {
      titlesRunning = false;
    }
  }

  function runStepTitlesBurst() {
    updateStepTitles();
    window.setTimeout(updateStepTitles, 0);
    window.setTimeout(updateStepTitles, 150);
    window.setTimeout(updateStepTitles, 400);
    window.setTimeout(updateStepTitles, 800);
  }

  function scheduleStepTitles() {
    if (titlesBurstQueued) return;
    titlesBurstQueued = true;
    window.requestAnimationFrame(function () {
      titlesBurstQueued = false;
      runStepTitlesBurst();
    });
  }

  function bindAddOnsTitleObserver() {
    var modal = document.getElementById('lensadvizor-prescription-modal');
    if (!modal || modal.dataset.ciwAddOnsTitleObs === '1') return;
    modal.dataset.ciwAddOnsTitleObs = '1';

    if (typeof MutationObserver === 'undefined') return;

    new MutationObserver(function () {
      if (!isEyeglassFlow()) return;
      scheduleStepTitles();
    }).observe(modal, {
      childList: true,
      subtree: true
    });
  }

  var EVENTS = [
    'LensAdvizor:prescriptionTypes:rendered',
    'LensAdvizor:render:submissionMethods',
    'LensAdvizor:lens:rendered',
    'LensAdvizor:lensOptions:rendered',
    'LensAdvizor:addOns:rendered',
    'LensAdvizor:selectLensModal:open',
    'LensAdvizor:component:DidMount'
  ];

  function bindStepTitles() {
    EVENTS.forEach(function (eventName) {
      document.addEventListener(eventName, function () {
        scheduleStepTitles();
        bindAddOnsTitleObserver();
      });
    });

    document.addEventListener(
      'click',
      function (event) {
        if (
          !event.target.closest(
            'lensadvizor-btn, #la-select-lenses-btn, .la-select-lenses-btn, [class*="la-select-lenses"]'
          )
        ) {
          return;
        }
        window.setTimeout(scheduleStepTitles, 300);
      },
      true
    );

    document.addEventListener(
      'change',
      function (event) {
        if (!event.target.matches('input[type="radio"].la-tap-select')) return;
        if (
          !event.target.closest(LENS_GROUP_STEP_SELECTOR) &&
          !event.target.closest(LENSES_STEP_SELECTOR)
        ) {
          return;
        }
        scheduleStepTitles();
      },
      true
    );

    document.addEventListener('ciw-la-lens-package:selection-changed', scheduleStepTitles);
    document.addEventListener('ciw-la-lens-color:continue-sync', scheduleStepTitles);
    document.addEventListener('ciw-la-lens-thickness:continue-sync', scheduleStepTitles);
    document.addEventListener('ciw-la-lens-color:combined-phase-b', scheduleStepTitles);
    document.addEventListener('ciw-la-sunglasses-lens-selection:changed', scheduleStepTitles);
    document.addEventListener('ciw-la-sunglasses-lens-selection:confirmed', scheduleStepTitles);
    document.addEventListener('ciw-la-transitions-drawer:changed', scheduleStepTitles);
    document.addEventListener('ciw-la-transitions-drawer:confirmed', scheduleStepTitles);

    document.addEventListener(
      'click',
      function (event) {
        if (!event.target.closest('.ciw-la-gusa-back-btn, .la-steeper-back')) return;
        scheduleStepTitles();
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindStepTitles);
  } else {
    bindStepTitles();
  }

  function injectPackageWidthFixStyles() {
    if (document.getElementById('ciw-la-package-width-fix-inline')) return;

    var style = document.createElement('style');
    style.id = 'ciw-la-package-width-fix-inline';
    style.textContent =
      'body.template-product.la-modal-open:is(:has(.ciw-pdp),:has(.cl-section)) .la-choose-prescription-wrapper.la-render-options:not(.ciw-la-lens-color-step) .la-horizontal-boxy-lenses-wrapper{display:flex;flex-direction:column;gap:0;margin-top:0;width:100%;max-width:100%}' +
      'body.template-product.la-modal-open:is(:has(.ciw-pdp),:has(.cl-section)) .la-choose-prescription-wrapper.la-render-options:not(.ciw-la-lens-color-step) :is(.la-horizontal-boxy-label-wrapper,.la-label-btn-wrapper){width:100%!important;max-width:100%!important;flex:1 1 100%!important;flex-basis:100%!important;margin:0 0 10px!important;box-sizing:border-box!important}' +
      'body.template-product.la-modal-open:is(:has(.ciw-pdp),:has(.cl-section)) .la-choose-prescription-wrapper.la-render-options:not(.ciw-la-lens-color-step) :is(.la-horizontal-boxy-label-wrapper,.la-label-btn-wrapper):last-child{margin-bottom:0!important}' +
      'body.template-product.la-modal-open:is(:has(.ciw-pdp),:has(.cl-section)) .la-choose-prescription-wrapper.la-render-options:not(.ciw-la-lens-color-step) :is(.la-horizontal-boxy-label-wrapper .la-label-btn,label.la-label-btn,div.la-label-btn){width:100%!important;max-width:100%!important;box-sizing:border-box!important}' +
      '@media screen and (max-width:749px){body.template-product.la-modal-open:is(:has(.ciw-pdp),:has(.cl-section)) .la-choose-prescription-wrapper.la-render-options:not(.ciw-la-lens-color-step){padding-left:max(18px,env(safe-area-inset-left,0px))!important;padding-right:max(18px,env(safe-area-inset-right,0px))!important}}' +
      '@media screen and (min-width:750px){body.template-product.la-modal-open #lensadvizor-prescription-modal .la-choose-prescription-wrapper.la-render-options:not(.ciw-la-lens-color-step) :is(.la-horizontal-boxy-layout-wrapper,.la-horizontal-boxy-lenses-wrapper,.la-horizontal-boxy-label-wrapper,.la-label-btn-wrapper,label.la-label-btn,div.la-label-btn){width:100%!important;max-width:100%!important;flex:1 1 100%!important;flex-basis:100%!important;box-sizing:border-box!important}body.template-product.la-modal-open #lensadvizor-prescription-modal .la-choose-prescription-wrapper.la-render-options:not(.ciw-la-lens-color-step){padding-left:max(18px,env(safe-area-inset-left,0px))!important;padding-right:max(18px,env(safe-area-inset-right,0px))!important}}' +
      /* Choose progressive type (transitions flow): price top-right like Choose lens package, both devices. */
      'body.template-product.la-modal-open:is(:has(.ciw-pdp),:has(.cl-section)) .la-choose-prescription-wrapper.ciw-la-progressive-type-options-step :is(label.la-label-btn,div.la-label-btn){position:relative!important}' +
      'body.template-product.la-modal-open:is(:has(.ciw-pdp),:has(.cl-section)) .la-choose-prescription-wrapper.ciw-la-progressive-type-options-step .la-label-title{padding-right:72px!important;box-sizing:border-box!important}' +
      'body.template-product.la-modal-open:is(:has(.ciw-pdp),:has(.cl-section)) .la-choose-prescription-wrapper.ciw-la-progressive-type-options-step .la-label-price.la-option-pricing{position:absolute!important;top:12px!important;right:12px!important;left:auto!important;bottom:auto!important;margin:0!important;padding:0!important;font-family:Inter,Arial,sans-serif!important;font-size:15px!important;font-weight:400!important;color:#1f3159!important;line-height:1.25!important;text-align:right!important;width:auto!important}' +
      /* Mobile only: keep icon + text on one row (icon-ready for future logos), just like Lens Type. */
      '@media screen and (max-width:749px){' +
      /* The step's options render inside a .la-prescription-wrapper.la-option-container, which trips product.css's "submission step = white content-body" rule. Restore the gray full-bleed above the title. */
      'body.template-product.la-modal-open:is(:has(.ciw-pdp),:has(.cl-section)) #lensadvizor-prescription-modal .la-prescription-modal-content-body:has(.la-choose-prescription-wrapper.ciw-la-progressive-type-options-step){background:#f4f4f4!important}' +
      'body.template-product.la-modal-open:is(:has(.ciw-pdp),:has(.cl-section)) .la-choose-prescription-wrapper.ciw-la-progressive-type-options-step :is(label.la-label-btn,div.la-label-btn){display:flex!important;flex-direction:row!important;align-items:center!important}' +
      'body.template-product.la-modal-open:is(:has(.ciw-pdp),:has(.cl-section)) .la-choose-prescription-wrapper.ciw-la-progressive-type-options-step :is(.la-label-image,.la-label-image-wapper){flex:0 0 auto!important;display:flex!important;align-items:center!important;justify-content:center!important;margin-right:12px!important}' +
      'body.template-product.la-modal-open:is(:has(.ciw-pdp),:has(.cl-section)) .la-choose-prescription-wrapper.ciw-la-progressive-type-options-step :is(.la-label-image,.la-label-image-wapper) :is(img,svg){width:36px!important;height:36px!important;object-fit:contain!important}' +
      'body.template-product.la-modal-open:is(:has(.ciw-pdp),:has(.cl-section)) .la-choose-prescription-wrapper.ciw-la-progressive-type-options-step .la-label-content-box{flex:1 1 auto!important;min-width:0!important}' +
      '}';
    document.head.appendChild(style);
  }

  injectPackageWidthFixStyles();
})();
